'use strict';

/**
 * Calculates the width of the browser's scrollbar.
 *
 * @function scrollbarWidth
 * @returns {number} The width of the scrollbar in pixels.
 */
function scrollbarWidth() {
    const $d = $('<div style="position:absolute;top:-9999px;width:50px;height:50px;overflow-y:scroll;"></div>').appendTo('body');
    const el = $d[0]; // get the native DOM element
    const w = el.offsetWidth - el.clientWidth; // px
    $d.remove();
    return w;
}

/**
 * Applies padding to elements with the 'back-ground-scroll' class based on the scrollbar width.
 *
 * @function applyPadding
 * @returns {void} This function does not return anything.
 */
function applyScrollbarPadding() {
    const w = scrollbarWidth();
    const classicScroll = w > 0;
    if (classicScroll) {
        $('.back-ground-scroll').css('padding-right', w + 'px');
    } else {
        $('body').css('padding-right', 0 + 'px');
    }
}

module.exports = {
    applyScrollbarPadding: applyScrollbarPadding
};
